import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  apiUrl = 'https://api.rozgarsarthi.sprrg.in/api/Contact';

  constructor(private http: HttpClient) {}

  saveConsultation(data: any) {
    return this.http.post(this.apiUrl, data);
  }
}